import { useState } from "react";
import PhoneInput from "react-phone-number-input";
import { validateForm } from "./validator";
import { preregister } from "../../../api/events";
import EventSummary from "../EventSummary";

export const PreRegisterForm = ({ event = {}, preRegLabel = false }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [submitError, setSubmitError] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [terms, setTerms] = useState([
    {
      text: `I understand that I will receive necessary communications (such as confirmations, passes, receipts, etc..) regarding ${event?.title}.`,
      isChecked: false,
      isRequired: true,
    },
    {
      text: `I agree to receive marketing communications from ${event?.title} and it's organizers.`,
      isChecked: false,
      isRequired: false,
    },
  ]);

  const disableSubmit =
    isLoading ||
    terms.some((item) => !item.isChecked && item.isRequired) ||
    !firstName ||
    !lastName ||
    !email ||
    !phoneNumber;

  const handleFormSubmit = (data) => {
    setIsLoading(true);
    setSubmitError("");
    setIsFormSubmitted(false);
    const errors = validateForm(data);
    setFormErrors(errors);
    if (Object.keys(errors)?.length === 0) {
      preregister({ ...data, event: event?.id, tag: preRegLabel })
        .then((response) => {
          if (
            response.status &&
            response.status >= 200 &&
            response.status < 300
          ) {
            setIsFormSubmitted(true);
          }
        })
        .catch((err) => {
          if (err?.response?.status === 400) {
            setSubmitError("You are already subscribed");
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };

  const clearErrors = (key) => {
    setFormErrors((prev) => {
      const copy = { ...prev };
      delete copy[key];
      return copy;
    });
  };

  return (
    <div className="preregistration">
      {true && (
        <>
          <EventSummary event={event} />
          <div className="container">
            <h2 className="preregistration__subtitle">Pre-Register now to get advance access
              for <strong>{preRegLabel}</strong></h2>
            <div className="guests">
              <div className=" guest-item">
                <div className="registration-form__input-group--double">
                  <div className="registration-form__input-group">
                    <lable
                      htmlFor="firstName"
                      className="registration-form__label registration-form__label--required"
                    >
                      First Name
                    </lable>
                    <div className="registration-form__input-box">
                      <input
                        name="firstName"
                        type="text"
                        value={firstName}
                        placeholder="First Name"
                        onChange={(e) => {
                          setFirstName(e.target.value);
                          clearErrors("firstName");
                        }}
                        onBlur={() => setFirstName((prev) => prev.trim())}
                        className={
                          "registration-form__input" +
                          (formErrors?.firstName
                            ? " registration-form__input--error"
                            : "")
                        }
                      />
                    </div>

                    {formErrors?.firstName && (
                      <p className="error-message registration-form__input-error-message">
                        {formErrors.firstName}
                      </p>
                    )}
                  </div>
                  <div className="registration-form__input-group">
                    <lable
                      htmlFor="lastName"
                      className="registration-form__label registration-form__label--required"
                    >
                      Last Name
                    </lable>
                    <div className="registration-form__input-box">
                      <input
                        name="lastName"
                        type="text"
                        value={lastName}
                        placeholder="Last Name"
                        onChange={(e) => {
                          clearErrors("lastName");
                          setLastName(e.target.value);
                        }}
                        onBlur={() => setLastName((prev) => prev.trim())}
                        className={
                          "registration-form__input" +
                          (formErrors?.lastName
                            ? " registration-form__input--error"
                            : "")
                        }
                      />
                    </div>

                    {formErrors?.lastName && (
                      <p className="error-message registration-form__input-error-message">
                        {formErrors.lastName}
                      </p>
                    )}
                  </div>
                </div>
                <div className="registration-form__input-group--double">
                  <div className="registration-form__input-group">
                    <lable
                      htmlFor="email"
                      className="registration-form__label registration-form__label--required"
                    >
                      Email
                    </lable>
                    <div className="registration-form__input-box">
                      <input
                        name="email"
                        type="text"
                        value={email}
                        placeholder="Email"
                        onChange={(e) => {
                          clearErrors("email");
                          setEmail(e.target.value);
                        }}
                        onBlur={() => setEmail((prev) => prev.trim())}
                        className={
                          "registration-form__input" +
                          (formErrors?.email
                            ? " registration-form__input--error"
                            : "")
                        }
                      />
                    </div>

                    {formErrors?.email && (
                      <p className="error-message registration-form__input-error-message">
                        {formErrors.email}
                      </p>
                    )}
                  </div>
                  <div className="registration-form__input-group">
                    <label
                      htmlFor="phone"
                      className="registration-form__label registration-form__label--required"
                    >
                      Phone
                    </label>
                    <div className="registration-form__input-box">
                      <PhoneInput
                        international={true}
                        value={phoneNumber || ""}
                        placeholder="Mobile Number"
                        onChange={(value) => {
                          clearErrors("phoneNumber");
                          setPhoneNumber(value);
                        }}
                        onBlur={() => setPhoneNumber((prev) => prev?.trim())}
                        className={
                          formErrors?.phoneNumber ? "PhoneInput--error" : ""
                        }
                      />
                    </div>
                    {formErrors?.phoneNumber && (
                      <p className="error-message registration-form__input-error-message">
                        {formErrors.phoneNumber}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="preregistration__terms-container">
              {terms.map((term, index) => (
                <label
                  className={`custom-checkbox custom-checkbox--square terms__btn ${
                    term?.isRequired ? "registration-form__label--required" : ""
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={term.isChecked}
                    onChange={(e) => {
                      setTerms((prev) => {
                        const copy = [...prev];
                        copy[index] = {
                          ...copy[index],
                          isChecked: e.target.checked,
                        };
                        return copy;
                      });
                    }}
                  />
                  <span className="checkmark"></span>
                  {term.text}
                </label>
              ))}
            </div>
            {submitError && (
              <p
                className="error-message"
                style={{
                  marginBottom: "2rem",
                }}
              >
                {submitError}
              </p>
            )}
            {isFormSubmitted && (
              <h2
                style={{
                  marginBottom: "2rem",
                }}
                className="checkout__subtitle"
              >
                Your request has been submitted please wait till you're notified
                by email
              </h2>
            )}
            <button
              type="submit"
              className={`btn btn--primary ${
                disableSubmit ? "btn--disabled" : ""
              }`}
              onClick={() =>
                handleFormSubmit({ firstName, lastName, email, phoneNumber })
              }
              disabled={disableSubmit}
            >
              Submit
            </button>
          </div>
        </>
      )}
      {false && ( 
        <div className="container">
          <div className="registration-form__input-group--double">
            <div className="registration-form__input-group">
              <lable
                htmlFor="email"
                className="registration-form__label registration-form__label--required"
              >
                Email
              </lable>
              <div className="registration-form__input-box">
                <input
                  name="email"
                  type="text"
                  value={email}
                  placeholder="Email"
                  onChange={(e) => {
                    clearErrors("email");
                    setEmail(e.target.value);
                  }}
                  onBlur={() => setEmail((prev) => prev.trim())}
                  className={
                    "registration-form__input" +
                    (formErrors?.email
                      ? " registration-form__input--error"
                      : "")
                  }
                />
              </div>

              {formErrors?.email && (
                <p className="error-message registration-form__input-error-message">
                  {formErrors.email}
                </p>
              )}
            </div>
            <div className="registration-form__input-group">
              <label
                htmlFor="phone"
                className="registration-form__label registration-form__label--required"
              >
                Phone
              </label>
              <div className="registration-form__input-box">
                <PhoneInput
                  international={true}
                  value={phoneNumber || ""}
                  placeholder="Mobile Number"
                  onChange={(value) => {
                    clearErrors("phoneNumber");
                    setPhoneNumber(value);
                  }}
                  onBlur={() => setPhoneNumber((prev) => prev?.trim())}
                  className={formErrors?.phoneNumber ? "PhoneInput--error" : ""}
                />
              </div>
              {formErrors?.phoneNumber && (
                <p className="error-message registration-form__input-error-message">
                  {formErrors.phoneNumber}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PreRegisterForm;
